import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ListNavigationComponent } from './components/list-navigation/list-navigation.component';
import { ListNavigationItemComponent } from './components/list-navigation-item/list-navigation-item.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ListNavigationComponent, ListNavigationItemComponent],
  exports: [ListNavigationComponent, ListNavigationItemComponent],
})
export class ListNavigationModule {}
